import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiFetch, getUserFacingErrorMessage } from './services/apiClient';
import './SupportPages.css';

const CATEGORIES = [
  { value: 'bug', label: 'Bug / something broken' },
  { value: 'sso_login', label: 'Login / SSO' },
  { value: 'billing', label: 'Billing' },
  { value: 'scheduling', label: 'Scheduling / calendar' },
  { value: 'ai_scoring', label: 'AI scoring / analysis' },
  { value: 'other', label: 'Other' },
];

const PRIORITIES = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Normal' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
];

function SupportTicketNewPage() {
  const navigate = useNavigate();
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [category, setCategory] = useState('other');
  const [priority, setPriority] = useState('medium');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;
    setSaving(true);
    setError(null);
    try {
      const res = await apiFetch('/api/support-tickets', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          subject: subject.trim(),
          body: body.trim(),
          category,
          priority,
          source_url: typeof window !== 'undefined' ? window.location.href : null,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(
          getUserFacingErrorMessage(res.status, data, data.detail || 'Failed to create ticket')
        );
      }
      const id = data.ticket?.public_id || data.ticket?.id;
      navigate(`/support/${encodeURIComponent(id)}`);
    } catch (err) {
      setError(err.message || 'Failed to create ticket');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="support-page">
      <div className="support-header">
        <div>
          <p className="support-eyebrow">Help &amp; Support</p>
          <h1>New ticket</h1>
        </div>
        <Link to="/support" className="support-btn secondary">
          My tickets
        </Link>
      </div>

      <div className="glass-container support-card">
        <p className="support-lead">
          Describe the issue. Our team is notified at talentvibe@govcomsolutions.com and will
          reply on this ticket.
        </p>
        {error && <div className="support-error">{error}</div>}
        <form className="support-form" onSubmit={onSubmit}>
          <label>
            <span>Subject</span>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
              minLength={3}
              maxLength={255}
              placeholder="Short summary of the problem"
              disabled={saving}
            />
          </label>
          <label>
            <span>Category</span>
            <select value={category} onChange={(e) => setCategory(e.target.value)} disabled={saving}>
              {CATEGORIES.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </select>
          </label>
          <label>
            <span>Priority</span>
            <select value={priority} onChange={(e) => setPriority(e.target.value)} disabled={saving}>
              {PRIORITIES.map((p) => (
                <option key={p.value} value={p.value}>
                  {p.label}
                </option>
              ))}
            </select>
          </label>
          <label>
            <span>Details</span>
            <textarea
              rows={8}
              value={body}
              onChange={(e) => setBody(e.target.value)}
              required
              minLength={3}
              placeholder="What happened? What did you try?"
              disabled={saving}
            />
          </label>
          <div className="support-form-actions">
            <button type="submit" className="support-btn" disabled={saving}>
              {saving ? 'Submitting…' : 'Submit ticket'}
            </button>
            <Link to="/support" className="support-btn secondary">
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SupportTicketNewPage;
